<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />
    
    <v-row>

      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="entry.stockAdjustmentReasonId"
          v-bind="getObject('stockAdjustmentReasonId')"
          label="Motivo do Ajuste de Estoque"
          :items="extraData.accountContext.allStockAdjustmentReasons"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <StockAdjustmentReasonNew
              :inlineAddButton="true"
              @entry-created="stockAdjustmentReasonCreated"
              modelNameSingular="Motivo do Ajuste de Estoque"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <!-- <v-col cols="12" sm="8" md="4">
        <v-switch 
          v-model="entry.isStockEntryType" 
          inset 
          :label="entry.isStockEntryType ? 'Entrada em Estoque' : 'Saída de Estoque'"
          :disabled="readOnly">
        </v-switch>
      </v-col> -->

      <v-col cols="12" sm="10" md="8">
        <v-autocomplete
          v-model="entry.storageId"
          v-bind="getObject('storageId')"
          label="Estoque"
          :items="extraData.accountContext.allStorages"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <StorageNew
              :inlineAddButton="true"
              @entry-created="storageCreated"
              modelNameSingular="Estoque"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <DateField
          :inputData.sync="entry.date"
          v-bind="getObject('date')"
          label="Data do Ajuste"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.storageId">
        <StorageAdjustmentItemsIndex
          :storageAdjustmentItems="entry.entryMovementItemsAttributes"
          :storageAdjustment="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
          modelNameSingular="Item de Ajuste de Entrada de Estoque"
          modelNamePlural="Itens de Ajuste de Entrada de Estoque"
        />
      </v-col>

      <!-- v-if="entry.storageId && entry.isStockEntryType" -->

      <!-- <v-col cols="12" class="" >
        <EntryMovementItemsIndex
          :entryMovementItems="entry.entryMovementItemsAttributes"
          :entryStorageAdjustment="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
        />
      </v-col>

       <v-col cols="12" class="" v-if="entry.stockId && !entry.isStockEntryType">
        <StockAdjustmentConsumedItemsIndex
          :consumedItems="entry.consumedItemsAttributes"
          :stockAdjustment="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
        />
      </v-col> -->

      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="entry.operationId"
          v-bind="getObject('operationId')"
          label="Colheita"
          :items="extraData.accountContext.allCropsForAdjustment"
          item-value="id"
          item-text="fullName"
          :disabled="readOnly"
          autocomplete="off"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Observações"
          outlined
          autocomplete="off"
          :disabled="readOnly"
        ></v-textarea>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue";
import BaseUtil from "@shared_components/base_util.vue";
import StorageNew from "@models/storages/new.vue"
import StorageAdjustmentItemsIndex from "../storage_adjustment_items/index.vue";
import StockAdjustmentReasonNew from "@models/stocks/stock_adjustments/stock_adjustment_reasons/new.vue"


export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    StorageNew: StorageNew,
    StockAdjustmentReasonNew: StockAdjustmentReasonNew,
    BaseUtil: BaseUtil,
    StorageAdjustmentItemsIndex: StorageAdjustmentItemsIndex,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("form", this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    storageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.storageId = storage.id;
      this.entry.storage = storage;
    },
    stockAdjustmentReasonCreated: function(stockAdjustmentReason) {
      this.extraData.accountContext.allStockAdjustmentReasons.unshift(stockAdjustmentReason);
      this.entry.stockAdjustmentReasonId = stockAdjustmentReason.id;
      this.entry.stockAdjustmentReason = stockAdjustmentReason;
    },
  }
};
</script>

<style scoped></style>
